import { render, staticRenderFns } from "./operationcontent.vue?vue&type=template&id=36207ae2&scoped=true&"
import script from "./operationcontent.vue?vue&type=script&lang=js&"
export * from "./operationcontent.vue?vue&type=script&lang=js&"
import style0 from "./operationcontent.vue?vue&type=style&index=0&id=36207ae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36207ae2",
  null
  
)

export default component.exports